"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const AccountGroupsShare = ({ accountGroups, onAccessLevelChange }) => {
    const accessOptions = ['NONE', 'READ', 'WRITE'];
    return (<>
      <material_1.Typography variant="subtitle2" sx={{ pb: 2, mt: 2 }}> Assign Entity Permissions </material_1.Typography>
      <material_1.Box sx={({ palette }) => ({
            backgroundColor: palette.background.info,
            p: 1,
            borderRadius: 2,
            minWidth: 450,
        })}>
        <material_1.TableContainer component={material_1.Paper} elevation={0} sx={{
            '&.MuiPaper-root': {
                padding: 0,
                backgroundColor: 'inherit',
            },
        }}>
          <material_1.Table size="small" sx={{ borderCollapse: 'separate', borderSpacing: 0 }}>
            <colgroup>
              <col style={{ width: '48%' }}/>
              <col style={{ width: '10%' }}/>
              <col style={{ width: '16%' }}/>
              <col style={{ width: '16%' }}/>
            </colgroup>
            <material_1.TableHead>
              <material_1.TableRow>
                <material_1.TableCell sx={{ borderBottom: 'none', p: 0 }}>
                  <material_1.Typography variant="subtitle2">
                    Entity
                  </material_1.Typography>
                </material_1.TableCell>
                <material_1.TableCell align="center" sx={{ borderBottom: 'none', p: 0 }}>
                  <material_1.Typography variant="subtitle2">
                    None
                  </material_1.Typography>
                </material_1.TableCell>
                <material_1.TableCell align="center" sx={{ borderBottom: 'none', p: 0 }}>
                  <material_1.Typography variant="subtitle2">
                    View-Only
                  </material_1.Typography>
                </material_1.TableCell>
                <material_1.TableCell align="center" sx={{ borderBottom: 'none', p: 0 }}>
                  <material_1.Typography variant="subtitle2">
                    View & Edit
                  </material_1.Typography>
                </material_1.TableCell>
              </material_1.TableRow>
            </material_1.TableHead>
            <material_1.TableBody>
              {accountGroups.map((accountGroup) => (<material_1.TableRow key={accountGroup.id}>
                  <material_1.TableCell sx={{ borderBottom: 'none', p: 0 }}>{accountGroup.name}</material_1.TableCell>
                  {accessOptions.map((accessOption) => (<material_1.TableCell align="center" key={accessOption} sx={{ borderBottom: 'none', p: 0 }}>
                      <material_1.Radio checked={accountGroup.permission === accessOption} onChange={() => onAccessLevelChange(accountGroup.id, accessOption)} value={accessOption} name={`access-${accountGroup.id}`} color="primary" size="small"/>
                    </material_1.TableCell>))}
                </material_1.TableRow>))}
            </material_1.TableBody>
          </material_1.Table>
        </material_1.TableContainer>
      </material_1.Box>
    </>);
};
exports.default = AccountGroupsShare;
